import { toast } from 'sonner'

import { getErrorMessage } from '@fortem-monorepo/web-sdk'

type ToastApiErrorOptions = {
  description?: string
}

export const toastApiError = (
  error: unknown,
  title: string,
  options: ToastApiErrorOptions = {},
) => {
  const message = getErrorMessage(error)

  const description = [options.description, message !== title ? message : undefined]
    .filter(Boolean)
    .join(' · ')

  toast.error(title, {
    description: description || undefined,
  })
}
